import React, { Suspense, lazy, useEffect } from "react";
import { Switch, useLocation } from "react-router-dom";
import { SALRoute } from "./components/SALRoute";
import { useAuth } from "@sal/react.authentication";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { transitionDurationSpinners } from "./components/Settings";
import { useBooking } from "./components/BookingContextProvider";
import { redirectToDashboard } from "./code/common";

const bookingDetails = lazy(() => import("./pages/bookingDetails/BookingDetails"));
const availability = lazy(() => import("./pages/availability/Availability"));
const contactDetails = lazy(() => import("./pages/contactDetails/ContactDetails"));
const extras = lazy(() => import("./pages/extras/Extras"));
const review = lazy(() => import("./pages/review/Review"));
const animalDeclaration = lazy(() => import("./pages/animalDeclaration/AnimalDeclaration"));
const validateCreditCard = lazy(() => import("./pages/paymentDetails/ValidateCreditCard"));
const maintenance = lazy(() => import("./pages/maintenance/Maintenance"));
const settingRefresh = lazy(() => import("./pages/SettingRefresh/SettingRefresh"));

function Routes() {
	const { loading, booking, setLoading } = useBooking();
	const location = useLocation();
	const auth = useAuth();

	useEffect(() => {
		if (!auth.checkIfLoggedIn()) {
			auth.logout();

			if (location.pathname !== "/" && location.pathname !== "/settingRefresh") { //landing page, wont be logged in at this point
				redirectToDashboard(auth, booking, setLoading);
			}
		}
	}, [location.pathname]);

	return (
		<Suspense fallback={<Backdrop open={loading} transitionDuration={{ exit: transitionDurationSpinners }}><CircularProgress color="secondary" /></Backdrop>}>
			<Switch>
				<SALRoute exact path="/bookingDetails" component={bookingDetails} />
				<SALRoute exact path="/availability" component={availability} />
				<SALRoute exact path="/contactDetails" component={contactDetails} />
				<SALRoute exact path="/extras" component={extras} />
				<SALRoute exact path="/review" component={review} />
				<SALRoute exact path="/animalDeclaration" component={animalDeclaration} />
				<SALRoute exact path="/validateCreditCard" component={validateCreditCard} />
				<SALRoute exact path="/maintenance" component={maintenance} />
				<SALRoute exact path="/settingRefresh" component={settingRefresh} />
			</Switch>
		</Suspense>
	);
}

export default Routes;